export const getBookingConfigurationEndpoint = (latitude, longitude) => {
  const { endpoints: { geWebAPIBase } } = window.Grab.config;
  const urlSearchParams = new URLSearchParams({
    latitude,
    longitude,
  });
  return `${geWebAPIBase}/v2/booking/configuration?${urlSearchParams.toString()}`;
};

export default { getBookingConfigurationEndpoint };
